import { configureStore } from '@reduxjs/toolkit';
import { FLUSH, PAUSE, PERSIST, PURGE, REGISTER, REHYDRATE, persistReducer, persistStore } from 'redux-persist';
import autoMergeLevel2 from 'redux-persist/es/stateReconciler/autoMergeLevel2';
import storage from 'redux-persist/lib/storage';

import { authReducers } from './slices/authSlice';
import { birthChartReducer } from './slices/birthChartSlice';
import { catalogReducer } from './slices/catalogSlice';
import { chatsReducer } from './slices/chatsSlice';
import { featuresReducer } from './slices/featuresSlice';
import { globalReducer } from './slices/globalSlice';
import { memoryReducer } from './slices/memorySlice';
import { modalsReducer } from './slices/modalsSlice';
import { paymentsReducer } from './slices/paymentsSlice';
import { tarotReadingsReducer } from './slices/tarotReadingsSlice';
import { tiersReducer } from './slices/tiersSlice';
import { waitlistReducer } from './slices/waitlistSlice';

const nestedPersistConfig = {
    key: 'nested',
    storage,
    whitelist: ['dataStatus']
};

const userPersistConfig = {
    key: 'VEDA:firstChatMessageTime',
    storage,
    whitelist: ['userFirstChatMessageTime', 'accessToken', 'refreshToken', 'isChatsBlocked', 'user'],
    transforms: [],
    stateReconciler: autoMergeLevel2,
    children: [
        {
            key: 'test',
            ...nestedPersistConfig
        }
    ]
};

const persistedAuthReducer = persistReducer(userPersistConfig, authReducers);

export const store = configureStore({
    reducer: {
        chats: chatsReducer,
        auth: persistedAuthReducer,
        global: globalReducer,
        catalog: catalogReducer,
        memory: memoryReducer,
        payments: paymentsReducer,
        modals: modalsReducer,
        waitlist: waitlistReducer,
        features: featuresReducer,
        birthChart: birthChartReducer,
        tarotReadings: tarotReadingsReducer,
        tiers: tiersReducer
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER]
            }
        })
});

export const persistor = persistStore(store);
